export default __webpack_public_path__ + "images/N6.27b6cba.png";